

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Delegate } from '../models/delegate';
import { Department } from '../models/department';

@Injectable({
  providedIn: 'root'
})
export class DelegateService {
  apiEndpoint: string="";
  baseApiUrl: any;
  apiUniqueId: string = 'delegation/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E';

  constructor(private httpService: HttpWrapperService, 
    private http: HttpClient,
    private configService: ConfigService) { 
      this.apiEndpoint = this.configService.getConfigValue("apiEndpoint");
      this.apiEndpoint += this.apiUniqueId;
    }
    getAllDelegate(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<any>>{ 
      return this.httpService.get(this.apiEndpoint + '/getAllDelegation?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                   
        if (result.Success && result.Success ) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }

    viewDelegate(Delegation_Id?: string): Observable<Array<Delegate>> {
      return this.httpService.get(this.apiEndpoint + '/viewDelegation/' + (Delegation_Id ? Delegation_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    saveDelegate(Delegate: Delegate): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveDelegation/', Delegate).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    deleteDelegate(Delegation_Id?: string): Observable<any> {
      return this.httpService.post(this.apiEndpoint + '/deleteDelegation/' + (Delegation_Id ? Delegation_Id : '00000000-0000-0000-0000-000000000000'), Delegation_Id).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    checkDuplication(DelegationName?: string,Delegation_Id?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkDuplication?DelegationName=' + (DelegationName ? DelegationName : '')+ '&Delegation_Id=' + (Delegation_Id ? Delegation_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
          return result; 
      }));
    }


  
  }

